/**
 * Self-hosted webfont per storefront theme (KAN-1546), loaded only when a
 * storefront uses it. Themes missing here use a font the app already
 * ships (Geist) or a system font.
 *
 * Kept apart from ``siteThemes.ts`` so the catalog stays importable by
 * the edge middleware, which cannot bundle CSS imports.
 */

import type { SiteThemeKey } from "./siteThemes";

export const SITE_THEME_FONTS: Partial<Record<SiteThemeKey, () => Promise<unknown>>> = {
  prumysl: () =>
    Promise.all([
      import("@fontsource/ibm-plex-sans/400.css"),
      import("@fontsource/ibm-plex-sans/500.css"),
      import("@fontsource/ibm-plex-sans/600.css"),
    ]),
  studio: () => import("@fontsource-variable/bricolage-grotesque/index.css"),
  uhel: () => import("@fontsource-variable/instrument-sans/index.css"),
  svezi: () => import("@fontsource-variable/manrope/index.css"),
};
